import { render, staticRenderFns } from "./CrmCardContent.vue?vue&type=template&id=8f846914&"
import script from "./CrmCardContent.vue?vue&type=script&lang=ts&"
export * from "./CrmCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./CrmCardContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports